import $ from "jquery";

// $(document).ready(function () {
//   var quantitiy = 0;
//   $(".quantity-right-plus").click(function (e) {
//     // Stop acting like a button
//     e.preventDefault();
//     // Get the field name
//     var quantity = parseInt($("#quantity").val());
//     console.log(document.getElementById("quantity"));
//     // If is not undefined
//     let newQuantity = $("#quantity").val(quantity + 1);
//     // $("#quantity").val(quantity + 1);

//     // Increment
//     let snipcartButton = document.getElementById("snipcart-button");

//     snipcartButton.setAttribute("data-item-quantity", newQuantity.val());
//   });

//   $(".quantity-left-minus").click(function (e) {
//     // Stop acting like a button
//     e.preventDefault();
//     // Get the field name
//     var quantity = parseInt($("#quantity").val());

//     // If is not undefined

//     // Increment
//     if (quantity > 0) {
//       let newQuantity = $("#quantity").val(quantity - 1);

//       let snipcartButton = document.getElementById("snipcart-button");

//       snipcartButton.setAttribute("data-item-quantity", newQuantity.val());
//     }
//   });
// });
var self = this;

window.onDecrement = function (id) {
  // console.log("decrement", id);

  // Stop acting like a button
  // e.preventDefault();
  // Get the field name

  var quantity = $('input[id="quantity-' + id + '"]').val();
  // console.log("quantity", quantity);
  // If is not undefined

  // Increment
  if (quantity > 0) {
    let newQuantity = $('input[id="quantity-' + id + '"]').val(quantity - 1);

    let snipcartButton = document.getElementById("snipcart-button");

    snipcartButton.setAttribute("data-item-quantity", newQuantity.val());
  }
};

window.onIncrement = function (id) {
  // console.log("increment", id);
  var quantitiy = 0;

  // Stop acting like a button
  // e.preventDefault();
  // Get the field name
  var quantity = parseInt($('input[id="quantity-' + id + '"]').val());
  // console.log("quantity", quantity);
  // If is not undefined
  let newQuantity = $('input[id="quantity-' + id + '"]').val(quantity + 1);
  // $('input[id="quantity-' + id + '"]').val(quantity + 1);
  const container = document.querySelector("#test");
  // console.log(container);
  // Increment
  let snipcartButton = container.querySelectorAll("button[data-item-id]");

  snipcartButton.forEach((btn) => {
    // console.log("bts--->", btn.getAttribute("data-item-id"));
  });

  // console.log(snipcartButton);

  // snipcartButton.setAttribute("data-item-quantity", newQuantity.val());
};
